<template>
  <v-card class="feedback_filter_card">
    <v-card-text class="pa-3">
      <v-row no-gutters>
        <v-col cols="3">
          <b>{{ $t("statistics.lblTimeRange") }}:</b> {{ meetingDateRange }}
        </v-col>
        <v-col cols="4" class="pr-2">
          <v-row>
            <v-col cols="4" class="pr-0">
              <b>{{ $t("agenda.lblMeetingType") }}:</b>
            </v-col>
            <v-col cols="8">
              <span v-if="!selectedMeetingTypes.length">
                {{ $t("statistics.lblAll") }}
              </span>
              <v-card
                v-else
                flat
                max-height="70px"
                class="overflow-x-auto pr-1"
              >
                <v-chip
                  v-for="meetingType in selectedMeetingTypes"
                  :key="meetingType.id"
                  small
                  color="secondary darken-3"
                  class="ma-1 pl-2"
                >
                  {{ meetingType.label }}
                </v-chip>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="5">
          <v-row>
            <v-col cols="3" class="pr-0">
              <b>{{ $t("poll.lblRespondent") }} :</b>
            </v-col>
            <v-col cols="9">
              <v-card flat max-height="60px" class="overflow-x-auto">
                <v-chip
                  v-if="isAnonymousUser"
                  small
                  color="secondary darken-3"
                  class="ma-1 pl-2"
                >
                  <v-avatar left>
                    <v-img
                      contain
                      src="@/assets/images/NoPhotoIcon.png"
                    ></v-img>
                  </v-avatar>
                  <span>{{ $t("admin.lblAnonymous") }}</span>
                </v-chip>
                <v-chip
                  v-if="isFetchAllRespondents && !selectedUsers.length"
                  small
                  color="secondary darken-3"
                  class="ma-1 pl-2"
                >
                  <v-avatar left>
                    <v-img
                      contain
                      src="@/assets/images/NoPhotoIcon.png"
                    ></v-img>
                  </v-avatar>
                  <span>{{ $t("statistics.lblAll") }}</span>
                </v-chip>
                <v-chip
                  v-else
                  v-for="item in selectedUsers"
                  :key="item.id"
                  small
                  color="secondary darken-3"
                  class="ma-1 pl-2"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-avatar
                        v-if="item.registered_email"
                        left
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-img
                          v-if="item.profilePhoto"
                          contain
                          :src="item.profilePhoto"
                        ></v-img>
                        <v-img
                          v-else
                          contain
                          src="@/assets/images/NoPhotoIcon.png"
                        ></v-img>
                      </v-avatar>
                      <span v-if="item.firstName" v-bind="attrs" v-on="on">
                        {{ item.firstName + " " + item.lastName }}
                      </span>
                      <span v-else v-bind="attrs" v-on="on">
                        {{ item.registered_email }}</span
                      >
                    </template>
                    <span
                      >{{ $t("lblEmail") }}: {{ item.registered_email }}</span
                    >
                  </v-tooltip>
                </v-chip>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { formatDate } from "@/utils/util";

export default {
  name: "TopicFeedbackFilterDetails",
  props: {
    filterDetails: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      userList: (state) => state.people.userList,
    }),
    ...mapGetters({
      meetingTypes: "tenant/agendaMeetingTypes",
    }),
    locale() {
      return this.$i18n.locale;
    },
    displayDateFormat() {
      return this.locale !== "ja" ? "dd/MM/yyyy" : "yyyy/MM/dd";
    },
    users() {
      return this.userList.filter(
        (user) => Boolean(user.is_registered_user) && user.registered_email
      );
    },
    selectedUsers() {
      return this.userList.filter((user) =>
        this.selectedRespondent.includes(user.id)
      );
    },
    selectedRespondent() {
      return this.filterDetails.user_ids;
    },
    meetingDateRange() {
      return `${formatDate(
        new Date(this.filterDetails.start_date),
        this.displayDateFormat
      )} - ${formatDate(
        new Date(this.filterDetails.end_date),
        this.displayDateFormat
      )}`;
    },
    selectedMeetingTypes() {
      return this.meetingTypes.filter((m) =>
        this.filterDetails.meeting_type_ids.includes(m.id)
      );
    },
    isAnonymousUser() {
      return this.filterDetails.fetch_anonymous;
    },
    isFetchAllRespondents() {
      return this.filterDetails.fetchAllRespondents;
    },
  },
};
</script>

<style>
</style>